(function() {
  class TrWidget {

    htmlTemplate
    html
    css
    data
    customElement

    defineCustomElement(tag) {
      class CustomElement extends HTMLElement {
        constructor() {
          super();
          this.attachShadow({ mode: 'open' });
          this.render();
          customWidget(tag).customElement = this;
        }
        render() {
          this.shadowRoot.innerHTML = `
            <style>${customWidget(tag).css}</style>
            ${customWidget(tag).html}
          `;
        }
      }
      customElements.define(tag, CustomElement);
    }

    replaceVar (html, key, value) {
      // If null, undefined, false, empty string (""), except zero (0)
      if (!value && value !== 0) {
        return html;
      } else {
        return html.replaceAll(`{${key}}`, value);
      }
    };

    renderHTML(html, data, customTemplateHandler = null){
        // Generate HTML Container
      let htmlOutput = html

      Object.keys(data).forEach((key, i) => {
        htmlOutput = this.replaceVar(htmlOutput, key, data[key]);
      });

      // Get Template
      const el = document.createElement('div');
      el.innerHTML = htmlOutput;

       /*run custom template handler*/ 
      let cth = '';
      if(customTemplateHandler){
        cth = customTemplateHandler(data, el);
      }

      return el.innerHTML;
    }

    initTemplate(html, css, data, tag) {
      this.htmlTemplate = html;
      this.html = html;
      this.css = css;
      this.data = data;
      this.defineCustomElement(tag);
      document.body.insertAdjacentHTML('beforeend', `<${tag}></${tag}>`);
    }

    updateTemplate(containerData, supportersData = null, customTemplateHandler = null) {
      this.data = Object.assign(this.data || {}, containerData);
      if(supportersData){
        this.data['supporters'] = supportersData;
      }
      this.html = this.renderHTML(this.htmlTemplate, this.data, customTemplateHandler);
      this.customElement.render();
    }
  }

  const widgets = {};

  window['customWidget'] = function(tag) {
    if (!widgets[tag]) { 
      widgets[tag] = new TrWidget(); 
    }
    return widgets[tag];
  };

})();